import { createInjectionKey } from 'naive-ui/es/_utils'
import type { StorageInjection } from './types'

export const cloudStorageInjectionKey = createInjectionKey<StorageInjection>('erp-storage-cloud')
